export default "__VITE_ASSET__L0dqyLWj__"